
import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';
import { Prop, Watch } from 'vue-property-decorator';

import CommonTitle from './components/commonTitle.vue';

@Component({
  components: { CommonTitle }
})
export default class OnLineClass extends Vue {
  docClassList: any = [
    {
      url:
        'https://lexiangla.com/classes?category_id=95a06838b3cf11eaba370a58ac1318b5&company_from=409301b0c06111e88af75254002b9121',
      title: '售前知识'
    },
    {
      url:
        'https://lexiangla.com/classes?category_id=a0ac8c84b3cf11eab3170a58ac13271c&company_from=409301b0c06111e88af75254002b9121',
      title: '产品及交付知识'
    },
    {
      url:
        'https://lexiangla.com/classes?category_id=a8c2675eb3cf11eaa86a0a58ac13241e&company_from=409301b0c06111e88af75254002b9121',
      title: '产品业务标准化'
    },
    {
      url:
        'https://lexiangla.com/classes?category_id=7c4946c0b3cf11ea9bcf0a58ac134921&company_from=409301b0c06111e88af75254002b9121',
      title: '客户升级'
    },
    {
      url:
        'https://lexiangla.com/classes?category_id=8395cafcb3cf11eaae000a58ac135e4d&company_from=409301b0c06111e88af75254002b9121',
      title: '其他'
    }
  ];
  @Getter docHomelist: any;
  // @Getter docClassList: any;
  // @Action('getHomelist') getHomelist: Function;
  @Action('getHomelistPar') getHomelistPar: Function;
  mounted() {
    //this.getHomelistPar({ groupName: 'Homepage' });
  }
  onClick(url: any) {
    // this.$router.push({
    //   path: '/course',
    //   query: {
    //     type: ID
    //   }
    // });
    window.open(url, '_blank');
  }
}
